module.exports = __webpack_public_path__ + "img/c9bb515d0ea2b7440e3413b7ed9ff558.svg";